import Link from "next/link";
import useCRMTheme from "@/hooks/useCRMTheme";

const Logo = ({ sx = {}, isPublic = false }) => {
  const { navbarLogo } = useCRMTheme(isPublic);
  return (
    <Link href="/crm" className="link-logo">
      {/* <LogoComponent login /> */}
      <div
        style={{
          // maxWidth: "170px",
          maxHeight: "30px",
          marginRight: "10px",
          marginTop: "-13px",
          ...sx,
        }}
      >
        <img
          src={navbarLogo}
          style={{
            height: "auto",
            maxHeight: "inherit",
          }}
        />
      </div>
    </Link>
  );
};

export default Logo;
